// ============================================================
// SevenStars SmartCare Passport — Supabase Client
// ============================================================
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://vgsjychsfocjxzikapof.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZnc2p5Y2hzZm9janh6aWthcG9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI5MDYwNTYsImV4cCI6MjA5ODQ4MjA1Nn0.HC87mXXmVuEi2JGKvQVAVRB-3CoilgYLlRhGov7YI6w';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
